<template>
		<div class="content home-page">
		<Header></Header>
			<div class="information2">
        <div class="back info" @click="back" style="margin-top: 40px">
          <img width="70" src="../../static/images/back.png" />
        </div>
				<div class="book-rule-content" >
					<div class="">
						<p class="fs50 ac"><span>{{$t('book_rule')}}</span></p>
						<p class="mt30 content"></p>
            <div class="table-container">
              <table class="level-table">
                <thead >
                <tr>
                  <th>{{$t('Level')}}</th>
                  <th>{{$t('Book_in_Need')}}</th>
                  <th>{{$t('Coin_in_Need')}}</th>
                  <th>{{$t('Coin_Bonus')}}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="level in levels" :key="level.level">
                  <td>{{ level.level }}</td>
                  <td>{{ level.books }}</td>
                  <td>{{ level.coins }}</td>
                  <td>{{ level.bonus }}</td>
                </tr>
                </tbody>
              </table>
            </div>
					</div>
				</div>
			</div>
		</div>
</template>
<script>
import Header from '../components/Header'
export default {
    components:{
		Header
    },
    data() {
        return {
			    list:[],
          levels: [
            { level: 1, books: 1, coins: 200, bonus: 1.05 },
            { level: 2, books: 2, coins: 400, bonus: 1.1 },
            { level: 3, books: 4, coins: 600, bonus: 1.15 },
            { level: 4, books: 6, coins: 800, bonus: 1.2 },
            { level: 5, books: 8, coins: 1000, bonus: 1.25 },
            { level: 6, books: 10, coins: 1200, bonus: 1.3 },
            { level: 7, books: 15, coins: 2000, bonus: 1.35 },
            { level: 8, books: 20, coins: 2500, bonus: 1.4 },
            { level: 9, books: 25, coins: 3000, bonus: 1.45 },
            { level: 10, books: 30, coins: 3500, bonus: 1.5 },
            { level: 11, books: 35, coins: 4000, bonus: 1.55 },
            { level: 12, books: 40, coins: 4500, bonus: 1.6 },
            { level: 13, books: 45, coins: 5000, bonus: 1.65 },
            { level: 14, books: 50, coins: 5500, bonus: 1.7 },
            { level: 15, books: 55, coins: 6000, bonus: 1.75 },
            { level: 16, books: 60, coins: 6500, bonus: 1.8 },
            { level: 17, books: 65, coins: 7000, bonus: 1.85 },
            { level: 18, books: 70, coins: 7500, bonus: 1.9 },
            { level: 19, books: 75, coins: 8000, bonus: 1.95 },
            { level: 20, books: 80, coins: 8500, bonus: 2 },
            { level: 21, books: 85, coins: 9000, bonus: 2.05 },
            { level: 22, books: 90, coins: 9500, bonus: 2.1 },
            { level: 23, books: 95, coins: 10000, bonus: 2.15 },
            { level: 24, books: 100, coins: 10500, bonus: 2.2 },
            { level: 25, books: 105, coins: 11000, bonus: 2.25 },
            { level: 26, books: 110, coins: 11500, bonus: 2.3 },
            { level: 27, books: 115, coins: 12000, bonus: 2.35 },
            { level: 28, books: 120, coins: 12500, bonus: 2.4 },
            { level: 29, books: 125, coins: 13000, bonus: 2.45 },
            { level: 30, books: 130, coins: 13500, bonus: 2.5 }
          ]
		}
    },
	created(){

	},
    methods: {
		back(){
			this.$router.go(-1);
		},
	}
}
</script>
<style>
/* Add some basic table styling */
.table-container {
  margin: 20px auto;
  max-width: 90%;
  overflow-x: auto;
}

.level-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.level-table th, .level-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}

.level-table th {
  background-color: #28da76;
  font-weight: bold;
}

.level-table tr:nth-child(even) {
  //background-color: #f9f9f9;
}

.level-table tr:hover {
  background-color: #f1f1f1;
}
</style>



// WEBPACK FOOTER //
// src/page/bookRule.vue